import {
  EDIT_INN, EDIT_NAME, EDIT_SHORT_NAME, EDIT_OGRN, EDIT_KPP, EDIT_RASS_SCHET, EDIT_EMAIL,
  EDIT_BANK_NAME, EDIT_BIK, EDIT_KORR_SCHET, EDIT_DIRECTOR_NAME, EDIT_DIRECTOR_FOOTING,
  EDIT_DIRECTOR_POST, EDIT_ADRESS, CLEAR_FIRM_FORM, REQUEST_GET_FIRM_SUCCESS,
  REQUEST_GET_FIRM_FAILED, CLEAR_FOUND_FIRM, CLEAR_FIRM_FORM_EXCEPT_INN, SET_VALID_FORM,
  REQUEST_CREATE_FIRM_SUCCESS, REQUEST_CREATE_FIRM_FAILED, EDIT_DEFAULT_DEF_PAYMENT
} from "../actions/firm_add_actions";


const initialState = {
  inn: '',
  name: '',
  short_name: '',
  ogrn: '',
  kpp: '',
  adress: '',
  rass_schet: '',
  bank_name: '',
  bik: '',
  korr_schet: '',
  director_name: '',
  director_footing: '',
  director_post: '',
  email: '',
  default_def_payment: 0,
  valid_form: false,
  found_firm: {}
}


export const firmAddReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_GET_FIRM_SUCCESS: {
      return {
        ...state,
        found_firm: action.payload,
        valid_form: true
      }
    }
    case REQUEST_GET_FIRM_FAILED: {
      return {
        ...state,
        found_firm: {},
        valid_form: false
      }
    }
    case CLEAR_FOUND_FIRM: {
      return {
        ...state,
        found_firm: {}
      }
    }
    case REQUEST_CREATE_FIRM_SUCCESS: {
      return {
        ...state,
        inn: '',
        name: '',
        short_name: '',
        ogrn: '',
        kpp: '',
        adress: '',
        rass_schet: '',
        bank_name: '',
        bik: '',
        korr_schet: '',
        director_name: '',
        director_footing: '',
        director_post: '',
        email: '',
        default_def_payment: 0,
        valid_form: false,
        found_firm: {}
      }
    }
    case REQUEST_CREATE_FIRM_FAILED: {
      return {
        ...state
      }
    }
    case CLEAR_FIRM_FORM: {
      return {
        ...state,
        inn: '',
        name: '',
        short_name: '',
        ogrn: '',
        kpp: '',
        adress: '',
        rass_schet: '',
        bank_name: '',
        bik: '',
        korr_schet: '',
        director_name: '',
        director_footing: '',
        director_post: '',
        email: '',
        default_def_payment: 0,
        valid_form: false,
        found_firm: {}
      }
    }
    case CLEAR_FIRM_FORM_EXCEPT_INN: {
      return {
        ...state,
        name: '',
        short_name: '',
        ogrn: '',
        kpp: '',
        adress: '',
        rass_schet: '',
        bank_name: '',
        bik: '',
        korr_schet: '',
        director_name: '',
        director_footing: '',
        director_post: '',
        email: '',
        default_def_payment: 0,
        valid_form: false,
        found_firm: {}
      }
    }
    case SET_VALID_FORM: {
      return {
        ...state,
        valid_form: action.valid_form
      }
    }
    case EDIT_INN: {
      return {
        ...state,
        inn: action.inn
      }
    }
    case EDIT_NAME: {
      return {
        ...state,
        name: action.name
      }
    }
    case EDIT_SHORT_NAME: {
      return {
        ...state,
        short_name: action.short_name
      }
    }
    case EDIT_OGRN: {
      return {
        ...state,
        ogrn: action.ogrn
      }
    }
    case EDIT_KPP: {
      return {
        ...state,
        kpp: action.kpp
      }
    }
    case EDIT_ADRESS: {
      return {
        ...state,
        adress: action.adress
      }
    }
    case EDIT_BIK: {
      return {
        ...state,
        bik: action.bik
      }
    }
    case EDIT_BANK_NAME: {
      return {
        ...state,
        bank_name: action.bank_name
      }
    }
    case EDIT_KORR_SCHET: {
      return {
        ...state,
        korr_schet: action.korr_schet
      }
    }
    case EDIT_RASS_SCHET: {
      return {
        ...state,
        rass_schet: action.rass_schet
      }
    }
    case EDIT_DIRECTOR_NAME: {
      return {
        ...state,
        director_name: action.director_name
      }
    }
    case EDIT_DIRECTOR_FOOTING: {
      return {
        ...state,
        director_footing: action.director_footing
      }
    }
    case EDIT_DIRECTOR_POST: {
      return {
        ...state,
        director_post: action.director_post
      }
    }
    case EDIT_EMAIL: {
      return {
        ...state,
        email: action.email
      }
    }
    case EDIT_DEFAULT_DEF_PAYMENT: {
      return {
        ...state,
        default_def_payment: action.default_def_payment
      }
    }
    default: return state;
  }
}
